// import { fb } from "../firebase";
// import { firestore } from "../firebase";
let saveCartItems = cart => {
  localStorage.setItem("cart", JSON.stringify(cart));
};
let cartItems = JSON.parse(localStorage.getItem("cart"));

const state = {
  cart: cartItems || []
};

const getters = {
  getCartItems(state) {
    return state.cart;
  },
  getCartItemsNumber(state) {
    let itemsNumber = 0;
    state.cart.forEach(element => {
      itemsNumber += element.quantity;
    });
    return itemsNumber;
  },
  getTotalPrice(state) {
    let totalPrice = 0;
    state.cart.forEach(item => {
      totalPrice += item.price * item.quantity;
    });
    return totalPrice;
  }
};

const mutations = {
  addCartItem(state, payload) {
    let foundedItem = state.cart.find(item => item.id == payload.id);
    console.log(foundedItem);
    if (foundedItem) {
      foundedItem.quantity++;
    } else {
      state.cart.push(payload);
    }
    saveCartItems(state.cart);
  },
  deleteCartItem(state, payload) {
    // delete with the product id (pyload will be product id)
    // let item = state.cart.find(item => item.id == payload);
    // console.log(state.cart.indexOf(item));
    // state.cart.splice(state.cart.indexOf(item), 1);
    // saveCartItems(state.cart);

    // delete with index (payload will be the product index)
    state.cart.splice(payload, 1);
    saveCartItems(state.cart);
  },
  decreaseQuantity(state, payload) {
    let item = state.cart.find(item => item.id == payload);
    item.quantity > 1 ? item.quantity-- : "";
    saveCartItems(state.cart);
  },
  increaseQuantity(state, payload) {
    let item = state.cart.find(item => item.id == payload);
    item.quantity++;
    saveCartItems(state.cart);
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
